import {BaseDao} from "./BaseDao";
import {Observable} from "rxjs";
import {PostlogConfiguration} from "../../models/postlogConfiguration";
import {ApiHelper} from "../apiHelper";
import {ConstantMan} from "../constantMan";
import {DateTimeFormat} from "../../models/dateTimeFormat";

export class PostlogConfigurationDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.POSTLOGCONFIGS, apiHelper);
    }
}